import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthService} from "@services/auth.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {environment} from "@root/src/environments/environment";
import {User} from '@6grain/masofa-monolith-api-client/identity';
import {userNames} from '@app/utils/_msf';
@Injectable({
  providedIn: 'root'
})
export class NotReadyApiService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {

  }

  loadForemen(): Observable<any> {

    const apiUrl = environment.api + '/identity/Role/GetUsersInRole?roleName=Foreman';
    const token = this.authService.getToken();

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.get<any[]>(apiUrl, {headers})
      .pipe(
        map((response: any[]) => {
          if (response && Array.isArray(response)) {
            return response.map((item: User) => ({
              label: userNames(item),
              value: item?.id || item.id
            }));
          }
          return [];
        }))
  }


  loadFieldWorkers(): Observable<any> {
    const apiUrl = environment.api + '/identity/Role/GetUsersInRole?roleName=FieldWorker';
    const token = this.authService.getToken();

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.get<any[]>(apiUrl, {headers})
      .pipe(
        map((response: any[]) => {
          if (response && Array.isArray(response)) {
            return response.map((item: any) => ({
              label: userNames(item),
              value: item?.id || item.id
            }));
          }
          return [];
        }))
  }


  downloadFile(fileId: string): Observable<Blob> {
    return this.http.get(`${environment.api}/common/FileStorageItem/GetFile/${fileId}`, {
      responseType: 'blob'
    });
  }

  downloadFileWithProgress(fileId: string): Observable<any> {
    return this.http.get(`${environment.api}/common/FileStorageItem/GetFile/${fileId}`, {
      responseType: 'blob',
      reportProgress: true,
      observe: 'events'
    });
  }

  getFiledSummary(): Observable<any> {
    const apiUrl = environment.api + '/cropMonitoring/Field/GetSummary';
    const token = this.authService.getToken();

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.get<any[]>(apiUrl, {headers})
      .pipe(
        map((response: any[]) => {
          if (response && Array.isArray(response)) {
            return response;
          }
          return [];
        }))
  }

  getFarmerReport(params: any): Observable<any> {
    const apiUrl = environment.api + '/cropMonitoring/Report/GetByQuery';
    const token = this.authService.getToken();

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }


    return this.http.post<any[]>(apiUrl, params, {headers})
      .pipe(
        map((response: any[]) => {
          if (response && Array.isArray(response)) {
            return response;
          }
          return [];
        }))
  }

  getTotalFarmerReport(params: any): Observable<number> {
    const apiUrl = environment.api + '/cropMonitoring/Report/GetTotalCount';
    const token = this.authService.getToken();

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.post<any>(apiUrl, params, {headers}).pipe(
      map((response: any) => {
        if (typeof response === 'number') {
          return response;
        }
        if (response && typeof response.total === 'number') {
          return response.total;
        }
        if (response && typeof response.count === 'number') {
          return response.count;
        }
        const n = Number(response);
        return Number.isFinite(n) ? n : 0;
      }),
    );
  }

  GetIndexSeasonReports(params: any, index: string): Observable<any> {
    const apiUrl = environment.api + '/satellite/' + index + '/GetIndexSeasonReports';
    const token = this.authService.getToken();

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.post<any[]>(apiUrl, params, {headers})
      .pipe(
        map((response: any[]) => {
          return response;
        }))
  }






}
